import { Component, OnInit, NgZone, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { QdeService } from "src/app/services/qde.service";
import { WSCallDetailsData, CreatUpdateLead } from "src/app/model/creat-update-lead";
import { IwService } from "src/app/services/iw.service";
import { getDeviceSize, getCookie } from "src/app/utilities/utilities.file";
import { BRAND_APPROVED_PANDEDUPE_ERRORS, GENERIC_ERRORS, GENERIC_ERROR, ISTATACARD, VALIDATION_MSG, TOOLTIPS, base_https_url, BRAND_APPROVED_ERRORS, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { MatSliderChange, MatSlider } from '@angular/material/slider';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ThemeService } from 'src/app/services/theme.service';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';

declare var form_next_click: Function;
declare var _satellite: any;
declare var $: any;
declare var jQuery: any;
declare var AmoScript: Function;
declare var analytics: any;


@Component({
  selector: "app-professional",
  templateUrl: "./professional.component.html",
  styleUrls: ["./professional.component.scss"]
})
export class ProfessionalComponent implements OnInit {
  professionalForm: FormGroup;
  wsDetails = new WSCallDetailsData();
  professionReq = new CreatUpdateLead();
  occupations: any;
  eapplyFormLabel: any;
  today = new Date();
  minDate = new Date("1900-01-01");
  maxDate = new Date("1996-12-31");
  min_age: number;
  max_age: number;
  cardList: any;
  ageRange: any;
  city: any;
  state: any;
  public regex =
    "[A-Za-z]{3}[p,P,c,C,h,H,f,F,a,A,t,T,b,B,l,L,j,J,g,G]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}";
  // "[A-Za-z]{3}[p,P]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}";
  _cardName: any;
  _cardtype: any;
  _cardCategory: any;
  invalidPanattempt = 0;
  executionId: any;
  isMobile: boolean;
  @Input() cardDcrData: any;
  @Input() masterData: any;
  @Input() retrieveDataReceived: any;
  companiesToSearch: any[];
  filterCompany: any;
  secondSectionCompleted = false;
  panDedupe: boolean;
  stdCode: any;
  requestData: any;
  @Output() professionalSectionCompleted = new EventEmitter<any>();
  errorMessage: string;
  pinNotFound = false;
  providedPin: any;
  filterPin: any;
  @ViewChild("matProfessionalBlock") professionalBlock: ElementRef;
  @ViewChild("mySlider") mySlider: MatSlider;
  pinList = [];
  TATACARD = ISTATACARD;
  placeholder: boolean = false;
  designationToSearch: any;
  filterDesignation: any;
  genricError: any;
  validationMsgs: any;
  tooltips: any;
  errorMessage1: any;
  focusInput: boolean;
  themeParam: any = 'sbi';
  occupationType: any = '';
  designationImg: any;
  base_url = base_https_url;
  designationImgUrl: string;
  companyOptional: string;
  designationOptional: string;
  incomeOptional: string;
  pinOptional: string;
  requireFields = true;
  isBanca: boolean;
  bancaPromoConfig:any;
  isShortLeadRetrive: any;
  isShortLeadNew: any;
  dataFromDropdown:boolean =true;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  fromSwiftJourney: boolean;
  constructor(
    private fb: FormBuilder,
    private qdeService: QdeService,
    private iw: IwService,
    private ngZone: NgZone,
    private sharedService: SharedServiceService,
    private themeService : ThemeService,
    private router: Router,
    private loaderService: LoaderService,
    private sharedData: SharedServiceService
  ) {
    this.partnerCode = this.themeService.partnerCode;
   }

  ngOnInit() {
    
    /* Analytics added */
    // analytics.track('eapply__page__existing_application', {
    //   'PAGE_NAME': window["digitalData"].page.pageName,
    //   'PAGE_URL': window["digitalData"].page.PAGE_URL,
    //   'MODE_OF_CONVERSION': '',
    //   'IS_ORAGANIC': 'IS_ORAGANIC_value',
    //   'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
    //   'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
    //   'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
    //   'CHANNEL_NAME': this.sharedService.paramschannel,
    //   'JOURNEY_NAME': 'EAPPLY',
    //   'FIRST_NAME': this.wsDetails.WSCallUserFirstName,
    //   'LAST_NAME': this.wsDetails.WSCallUserLastName,
    //   'MIDDLE_NAME': this.wsDetails.WSCallUserMiddleName,
    //   'EMAIL_ID': this.wsDetails.WSCallUserEmailId,
    //   'MOBILE_NUM': this.wsDetails.WSCallUserMobileNumber,
    //   'CITY': this.wsDetails.WSCallUserCity,
    //   'CARD_TYPE': this.sharedService.sbic_card_Type
    //   });

    this.fromSwiftJourney = this.sharedService.fromSwiftJourney;
    this.fetchCompDesg();
    this.genricError = GENERIC_ERRORS;
    this.validationMsgs = VALIDATION_MSG;
    this.tooltips = TOOLTIPS;
    ISTATACARD ? this.designationImgUrl = this.base_url + "/tata-card-en/resources/img/eapply/" : this.designationImgUrl = this.base_url + "/sbi-card-en/resources/img/eapply/"
    this.designationImg = this.designationImgUrl + "Ocupation.svg";
    this.themeParam = this.themeService.themeParam;
    this.createForm();   
    console.log("masterData1", this.masterData);

    this.f.fcnCompanyName.valueChanges.subscribe(value => {
      console.log(this.f.fcnCompanyName);
      console.log(this.filterCompany);
      if (value && value.length >= 3 && this.companiesToSearch) {
        console.log("this.filterCompany" + this.filterCompany);
        console.log("inside value" +this.f.fcnOccupationType.value);
        this.filterCompany = this.companiesToSearch.filter(company =>
          //company.companyName.toLowerCase().startsWith(value.toLowerCase())
          company.cmpNm.toLowerCase().startsWith(value.toLowerCase())
          
        );

      } 
      else {
        this.filterCompany = [];
      }
    });
    this.f.fcnDesignation.valueChanges.subscribe(value => {
      if (value && value.length >= 2 && this.designationToSearch) {
        this.filterDesignation = this.designationToSearch.filter(designation =>
          designation.toLowerCase().startsWith(value.toLowerCase())
        );
      } else {
        this.filterDesignation = [];
      }
    });
    this.f.fcnOfcPin.valueChanges.subscribe(value => {
      if (value && value.length >= 2 && this.pinList) {
        this.filterPin = this.pinList.filter(pin => ('' + pin).startsWith(value));
      } else {
        this.filterPin = null;
      }
      this.fetchCityFromPin();

    });
    this.occupations = this.iw.getoccupationDropdown();
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    this.ageRange = this.iw.getAgePolicyForOccupation().card_occupation;
    this.bancaPromoConfig = this.iw.getBancaDefaultConfigurationDCR();

    this.companyOptional = this.eapplyFormLabel.companyname_text.companyname_label + '(Optional)';
    this.cardList = this.iw.getAgePolicyForOccupation().card_type_list;
    this.designationOptional = this.eapplyFormLabel.designation_text.designation_label + '(Optional)';
    this.incomeOptional = this.eapplyFormLabel.annualinc_text.annualinc_label + '(Optional)';
    this.pinOptional = this.eapplyFormLabel.officepin_text.officepin_label + '(Optional)';
    this.isBanca = this.sharedService.paramschannel && this.sharedService.paramschannel == '901' ? true : false;
    if (getDeviceSize() === "small") {
      this.isMobile = true;
    }
    window.onresize = e => {
      this.ngZone.run(() => {
        if (getDeviceSize() === "small") {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    };
    this.patchDetailsForRetrieve();
    this.isShortLeadRetrive = getCookie('isShortLeadRetrive');
    this.isShortLeadNew = getCookie('isShortLeadNew');
    if(this.isShortLeadRetrive === 'true' || this.isShortLeadNew === 'true') {
      this.qdeService.signedValueResponse = sessionStorage.getItem('ds');
    }


  }

  ngOnChanges() {
    const xml = this.cardDcrData;
    console.log("masterData2", this.masterData);
    if (xml) {
      this._cardName = xml.root.card_information.card_name
      this._cardtype = xml.root.card_information.card_type
      this._cardCategory = xml.root.card_information.card_category
    }
    if (this.masterData) {
      let list: any;
      if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
        list = this.masterData.bancaCityList;
      } else {
        list = this.masterData.cityList;
      }
      list.forEach(pinObj => { this.pinList.push(...pinObj.pin) });
      if (this.pinList) {
        this.pinList = this.pinList.filter((v, i, a) => a.indexOf(v) === i);
      }
      if(this.professionalForm){
        this.fetchCityFromPin();
      }
      // this.fetchCityFromPin();

    }
    if (this.retrieveDataReceived) {
      this.patchDetailsForRetrieve();
    }

  }


  createForm() {
    this.professionalForm = this.fb.group({
      fcnOccupationType: ["", Validators.required],
      fcnDesignation: ["", [Validators.required, Validators.pattern('[A-Za-z0-9\\s()-.&:\\/,_]*')]],
      fcnCompanyName: ["", [Validators.required, Validators.pattern('[^\\|<>\\?=;,!\\*]*')]],
      fcnOfcPin: ["", [Validators.required, Validators.pattern('^[1-9][0-9]{5}$'), Validators.minLength(6)]],
      fcnPan: ["", [Validators.required, Validators.pattern(this.regex)]],
      fcnIncome: ["", Validators.required],
      fcnDOB: ["", Validators.required]
    });
  }
  public hasError = (controlName: string, errorName: string) => {
    return this.professionalForm.controls[controlName].hasError(errorName);
  };

  get f() {
    return this.professionalForm.controls;
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  onSubmit() {

    if (IS_CAMPAIGN) {
      window["page"] = 'ev_qde_section2';
      window["transactionId"] = this.sharedService.amoSequeceNumber ? this.sharedService.amoSequeceNumber : '';
      AmoScript();
    }
    let labelsDisplay: any
    if (this.eapplyFormLabel) {
      if (this.eapplyFormLabel.occupation_text && this.eapplyFormLabel.occupation_text.occupation_label) {
        labelsDisplay = this.eapplyFormLabel.occupation_text.occupation_label
      } if (this.eapplyFormLabel.companyname_text && this.eapplyFormLabel.companyname_text.companyname_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.companyname_text.companyname_label
      } if (this.eapplyFormLabel.designation_text && this.eapplyFormLabel.designation_text.designation_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.designation_text.designation_label
      } if (this.eapplyFormLabel.pan_text && this.eapplyFormLabel.pan_text.pan_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.pan_text.pan_label
      } if (this.eapplyFormLabel.dob_text && this.eapplyFormLabel.dob_text.dob_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.dob_text.dob_label
      }
    }
    form_next_click(this.sharedService.cardName, 'Professional details', labelsDisplay);

    if (this.pinNotFound) {
      return;
    } else if (this.professionalForm.invalid) {
      Object.keys(this.f).forEach(key => {
        this.professionalForm.get(key).markAsTouched;
      });
      return;
    } else {
      let compAliase;
      let desigInList;
      console.log("desig", this.designationToSearch);
      console.log("comp", this.companiesToSearch);
      if (this.companiesToSearch) {
        console.log("Test comp");
      //compAliase = this.companiesToSearch.find(comp => comp.companyName === this.f.fcnCompanyName.value);
      compAliase = this.companiesToSearch.find(comp => comp.cmpNm === this.f.fcnCompanyName.value);
      //desigInList = this.designationToSearch.find(desg => desg === this.f.fcnDesignation.value);
      }
      if (this.designationToSearch) {
        console.log("Test desig");
      //compAliase = this.companiesToSearch.find(comp => comp.companyName === this.f.fcnCompanyName.value);
      desigInList = this.designationToSearch.find(desg => desg === this.f.fcnDesignation.value);
      }
      //this.qdeService.natureOfCompany = compAliase ? compAliase.natureOfCompany : 'C';
      console.log("natureOfCompany" ,this.qdeService.natureOfCompany );
      this.qdeService.designationFlag = desigInList ? '0' : '1';
      console.log("designationFlag" ,this.qdeService.designationFlag );

      let fNameOnPAN = this.qdeService.aboutData.WSCallUserFirstName ? this.qdeService.aboutData.WSCallUserFirstName: '';
      let midNameOnPAN = this.qdeService.aboutData.WSCallUserMiddleName ? this.qdeService.aboutData.WSCallUserMiddleName: '';
      let lastNameOnPAN = this.qdeService.aboutData.WSCallUserLastName ? this.qdeService.aboutData.WSCallUserLastName: '';

      let dob: any = new Date(this.f.fcnDOB.value);
      const d = dob.getDate();
      const m = dob.getMonth() + 1;
      const y = dob.getFullYear();
      dob = `${y}-${
        (m + "").length === 1 ? "0" + m : m
        }-${(d + "").length === 1 ? "0" + d : d}`;
        dob= dob+'T00:00:00.000Z';

      let DOBforPanCheck = `${(d + "").length === 1 ? "0" + d : d}/${
        (m + "").length === 1 ? "0" + m : m
        }/${y}`


      const panMismatchObject = {
        panNumber: this.f.fcnPan.value.trim(),
        firstName: fNameOnPAN ? fNameOnPAN : "",
        lastName: lastNameOnPAN ? lastNameOnPAN :  "",
        dateOfBirth: DOBforPanCheck,
        middleName: midNameOnPAN ? midNameOnPAN : "",
        nameOnCard: midNameOnPAN ? fNameOnPAN + ' ' + midNameOnPAN + ' ' + lastNameOnPAN : fNameOnPAN + ' ' + lastNameOnPAN
      };
      const panDedupeObject = {
        panNumber: this.f.fcnPan.value.trim()
      };

      
     

      this.wsDetails.WSCallUserOccupationCode =
        this.f.fcnOccupationType.value || null;
        this.wsDetails.WSCallUserCompany = compAliase ? compAliase.cmpNm : (this.f.fcnCompanyName.value ? (this.f.fcnCompanyName.value).substr(0,30): null);
        this.wsDetails.WSCallUserDesignation =
          (this.f.fcnDesignation.value ? (this.f.fcnDesignation.value).substr(0,40): null);
      this.wsDetails.WSCallUserAnnualIncomeValue =
        this.f.fcnIncome.value || null;
      this.wsDetails.WSCallUserOfficePincode = this.f.fcnOfcPin.value || null;
      this.wsDetails.WSCallUserPanNumber = this.f.fcnPan.value.trim() || null;
      this.wsDetails.WSCallUserDOB = dob;
      this.wsDetails.WSCallUpdateIncompleteAppFlag = 'Y';
      // this.wsDetails.WSCallPromoCode = this.sharedService.promoCode
      this.requestData = Object.assign({}, this.qdeService.aboutData, this.wsDetails);
      this.professionReq.wsCallDetailsData = this.requestData;
      this.professionReq = this.trimObject(this.professionReq);
      
      this.qdeService
        .panMismatch(panMismatchObject)
        .subscribe((response: any) => {
          const result1 = { ...response.body };
          if (result1 && result1.PanNameMatchErrorRs && result1.PanNameMatchErrorRs.status && result1.PanNameMatchErrorRs.status.toLowerCase() === 'failure') {
            if (result1.PanNameMatchErrorRs.errorCode && result1.PanNameMatchErrorRs.errorCode == '300') {
              this.errorMessage = BRAND_APPROVED_ERRORS.panStatus300;
              window["digitalData"].error = { message: this.errorMessage };
              if(window['_satellite']){
                _satellite.track('form_error');
              }
            } else {
              this.errorMessage = GENERIC_ERROR;
              window["digitalData"].error = { message: GENERIC_ERROR };
              if(window['_satellite']){
                _satellite.track('form_error');
              }
            }
          } else if (
            result1 &&
            result1.PanNameMatchRsType &&
            result1.PanNameMatchRsType.panNameMatchStatus == true
          ) {
            this.qdeService.executionId =
              result1.PanNameMatchRsType.executionId;
            this.errorMessage = '';
            let accessToken: any;
            let expiryTime: any;
            if (response.headers && response.headers.get("access_token")) {
              accessToken = response.headers.get("access_token");
            }
            if (response.headers && response.headers.get("expiry_time")) {
              expiryTime = response.headers.get("expiry_time");
            }

            if (accessToken) {
              sessionStorage.setItem("s24_access_token", accessToken);
            }
            if (expiryTime) {
              sessionStorage.setItem("s24_expiry_time", expiryTime);
            }
            this.errorMessage = '';
            this.invalidPanattempt=0;
            this.callPanDedupe(panDedupeObject);
          } else if (
            result1 &&
            result1.PanNameMatchRsType &&
            result1.PanNameMatchRsType.panNameMatchStatus == false
          ) {
            ++this.invalidPanattempt;
            this.errorMessage = '';
            this.errorMessage = '';
            if (this.invalidPanattempt >= 3) {
              this.sharedService.abortMessage = BRAND_APPROVED_ERRORS.panNameMismatch;
              this.router.navigate(['', 'error']);
            }
          }
        }), error => {
          this.errorMessage = GENERIC_ERROR;
          window["digitalData"].error = { message: GENERIC_ERROR };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
        };
        let gemIdVal = this.sharedData.paramsgemid1;
    console.log("Value of gem id1 is",gemIdVal);
   // this.sharedData.paramsgemid1Val =  gemIdVal; 
    let gem1 = this.sharedData.paramsgemid1? this.sharedData.paramsgemid1 : '';
    }
  /* Analytics added */
  if(window['analytics']){
    console.log("REQUIRED FIELDS",this.f);
    console.log("WS Details Field",this.wsDetails);
    console.log("RequestData",this.professionReq.wsCallDetailsData);
    analytics.track('eapply__click__next__submit_professional_details', {
      'MODE_OF_CONVERSION': '',
      'IS_ORGANIC': 'N',
      'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
      'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
      'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
      'CHANNEL_NAME': this.sharedService.paramschannel,
      'JOURNEY_NAME': 'EAPPLY',
      'COMPANY_NAME': this.f.fcnCompanyName.value,
      'DOB': this.f.fcnDOB.value,
      'DESIGNATION': this.f.fcnDesignation.value,
    'ANNUAL_SALARY': this.f.fcnIncome.value, 
      'OFFICE_PIN_CODE': this.f.fcnOfcPin.value,
      'pan': this.f.fcnPan.value,
      'OCCUPATION': this.f.fcnOccupationType.value,
      'CARD_TYPE': this.professionReq.wsCallDetailsData.WSCallCardType,
      'mobile_no': this.professionReq.wsCallDetailsData.WSCallUserMobileNumber,
      'First_Name': this.professionReq.wsCallDetailsData.WSCallUserFirstName,
      'Last_Name': this.professionReq.wsCallDetailsData.WSCallUserLastName,
      'email': this.professionReq.wsCallDetailsData.WSCallUserEmailId,
      'Residential_City': this.professionReq.wsCallDetailsData.WSCallUserCity 
      });
  }

}

  callPanDedupe(panDedupeObject) {
    this.qdeService
      .panDedupecheck(panDedupeObject)
      .subscribe((response: any) => {
        const dedupeResult = { ...response.body }
        if (dedupeResult && dedupeResult.PanDedupeErrorRs && dedupeResult.PanDedupeErrorRs.status && dedupeResult.PanDedupeErrorRs.status.toLowerCase() === 'failure') {
          if (dedupeResult.PanDedupeErrorRs.errorCode && dedupeResult.PanDedupeErrorRs.errorCode == '300') {
            this.errorMessage = BRAND_APPROVED_ERRORS.panStatus300;
            window["digitalData"].error = { message: this.errorMessage };
            if(window['_satellite']){
              _satellite.track('form_error');
            }
          } else {
            this.errorMessage = GENERIC_ERROR;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if(window['_satellite']){
              _satellite.track('form_error');
            }
          }
          this.errorMessage = GENERIC_ERROR;
        } else if (
          dedupeResult &&
          dedupeResult.PanDedupeRsType &&
          dedupeResult.PanDedupeRsType.panDedupeStatus == false
        ) {
          let accessToken: any;
          let expiryTime: any;
          this.errorMessage = '';
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }

          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
          this.errorMessage = '';
          this.callMaster();
        } else if (
          dedupeResult &&
          dedupeResult.PanDedupeRsType &&
          dedupeResult.PanDedupeRsType.panDedupeStatus == true
        ) {
          this.panDedupe = true;
          this.errorMessage = '';
          this.sharedService.panDedupeErrorMulticard = this.panDedupe;
          this.sharedService.abortMessage = BRAND_APPROVED_ERRORS.panDedupeFound;
          this.sharedService.pandedupeAbortMessage = BRAND_APPROVED_PANDEDUPE_ERRORS;
          this.router.navigate(['', 'error']);
        }
      }, err => {
        this.errorMessage = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
      });
  }

  callCreateUpdateLead(reqBody) {
    this.qdeService.createUpdateLead(reqBody).subscribe(
      (res: any) => {
        console.log("entering callCreateUpdate");
        if (res.LeadGenerationRes.WSCallStatusCode === "000") {
          console.log("success in create updating lead");
          this.qdeService.professionalData = this.wsDetails;
          this.qdeService.secondSectionData = this.requestData;
          this.errorMessage = '';
          this.errorMessage1 = '';
          let sequenceId = res.LeadGenerationRes.WSCallSequenceId ? res.LeadGenerationRes.WSCallSequenceId : '';
          this.sharedService.amoSequeceNumber = sequenceId;

          this.professionalSectionCompleted.emit({ 'completed': true, 'stepIndex': 2 });
        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode == "108" && res.LeadGenerationRes.WSCallStatusDescription) {
          console.log("else if in create updating lead");
          this.errorMessage1 = BRAND_APPROVED_ERRORS.duplicateRecord;
          this.errorMessage = '';
          window["digitalData"].error = { message: this.errorMessage1 };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode !== "000" && res.LeadGenerationRes.WSCallStatusDescription) {
          console.log("error message in createUpdatelead");
          this.errorMessage = res.LeadGenerationRes.WSCallStatusDescription;
          window["digitalData"].error = { message: this.errorMessage };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
          this.professionalSectionCompleted.emit({ 'completed': true, 'stepIndex': 1 });
          this.qdeService.professionalData = "";
        }
      }, err => {
        this.qdeService.professionalData = "";
        this.errorMessage1 = '';
        this.errorMessage = GENERIC_ERROR;
        console.log("error from createUpdate lead", this.errorMessage);
        window["digitalData"].error = { message: GENERIC_ERROR };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
      }
    );
  }

  onlypanallowed(event) {
    let match = event.key.match(this.regex);
    if (this.f.fcnPan.value && this.f.fcnPan.value.length <= 4) {
      let regex1 = /[A-Za-z]/;
      if (event.key.match(regex1)) {
        return true;
      } else {
        return false;
      }
    } else if (
      this.f.fcnPan.value && this.f.fcnPan.value.length >= 5 &&
      this.f.fcnPan.value.length <= 8
    ) {
      let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    } else if (this.f.fcnPan.value &&
      this.f.fcnPan.value.length >= 9 &&
      this.f.fcnPan.value.length <= 10
    ) {
      let regex2 = /[A-Za-z]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
  }

  numberOnly(event) {
    if (this.f.fcnOfcPin.value && this.f.fcnOfcPin.value.length < 1) {
      let regex1 = /[1-9]/;
      if (event.key.match(regex1)) {
        return true;
      } else {
        return false;
      }
    } else {
      let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
  }

  numberOnlyPhone(event) {
    this.focusInput = true;
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  minYear(minYears) {
    return this.today.getFullYear() - minYears;
  }

  maxYear(maxYears) {
    return this.today.getFullYear() - maxYears;
  }

  setAgeRange(event) {
    let name;
    let name1
    let todayDate:any;
    this.occupations.forEach(element => {
      if (element.key_value == this.f.fcnOccupationType.value)
        name1 = element.key_name
    });
    name = name1.replace(/[&\/\\#,+()$~%.'":*?<>{}' ']/g, '');
    name = name.replace(/' '/g, '');
    this.designationImg = this.designationImgUrl + name + ".png"
    this.retiredAndStudentValidation(event.value);

    if (this.cardList) {
      if (Array.isArray(this.cardList)) {
        this.cardList.forEach(card => {
          if (card.card_type == this._cardtype) {
            this.ageRange = card.card_occupation;
          }
        });
      } else {
        if (this.cardList.card_type == this._cardtype) {
          this.ageRange = this.cardList.card_occupation;
        }
      }
    }

    let selectedOccupation = [];
    selectedOccupation = this.ageRange.filter(
      occupation => occupation.occupation_type == this.f.fcnOccupationType.value
    );

    this.occupationType = this.f.fcnOccupationType.value;
    if (selectedOccupation && selectedOccupation.length) {
      this.min_age = this.minYear(selectedOccupation[0].min_age);
      this.max_age = this.maxYear(selectedOccupation[0].max_age);
      todayDate = new Date().getDate();
      todayDate = (''+ todayDate).length===1 ?  ('0'+todayDate) : todayDate ;
      this.maxDate = new Date((this.min_age) + "-01-" + todayDate);
      this.minDate = new Date((this.max_age) + "-01-" + todayDate);
      this.maxDate = new Date(this.maxDate.setMonth(new Date().getMonth() + 6));
      this.minDate = new Date(this.minDate.setMonth(new Date().getMonth()));
      // this.maxDate = new Date((this.min_age) + "-01-" + new Date().getDate());
      // this.minDate = new Date((this.max_age) + "-01-" + new Date().getDate());
      // this.maxDate = new Date(this.maxDate.setMonth(new Date().getMonth() + 6));
      // this.minDate = new Date(this.minDate.setMonth(new Date().getMonth()));
      return;
    } else {
      this.minDate = new Date("1900-01-01");
      this.maxDate = new Date("1996-12-31");
    }

  }

  retiredAndStudentValidation(value) {
    console.log(value);
    if (value === "P" || value === "T") {
      console.log("check retired fun");
      this.requireFields = false;
      this.professionalForm.get('fcnDesignation').setValidators(null);
      this.professionalForm.get('fcnDesignation').updateValueAndValidity();
      this.professionalForm.get('fcnCompanyName').setValidators(null);
      this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
      this.professionalForm.get('fcnOfcPin').setValidators(null);
      this.professionalForm.get('fcnOfcPin').setValidators([Validators.pattern('^[1-9][0-9]{5}$'), Validators.minLength(6)]);
      this.professionalForm.get('fcnOfcPin').updateValueAndValidity();
      this.professionalForm.get('fcnIncome').setValidators(null);
      this.professionalForm.get('fcnIncome').updateValueAndValidity();
    }
    else {
      if(this.dataFromDropdown && (value != "P" || value != "T")){
        console.log(value);
        console.log("inside if block in retiredandstudent fun");
        this.requireFields = true;
        this.professionalForm.get('fcnDesignation').setValidators([Validators.required,Validators.pattern('[A-Za-z0-9\\s()-.&:\\/,_]*')]);
        this.professionalForm.get('fcnDesignation').updateValueAndValidity();
        this.professionalForm.get('fcnCompanyName').setValidators([Validators.required,Validators.pattern('[^\\|<>\\?=;,!\\*]*')]);
        this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
        this.professionalForm.get('fcnOfcPin').setValidators([Validators.required, Validators.pattern('^[1-9][0-9]{5}$'), Validators.minLength(6)]);
        this.professionalForm.get('fcnOfcPin').updateValueAndValidity();
        this.professionalForm.get('fcnIncome').setValidators(Validators.required);
        this.professionalForm.get('fcnIncome').updateValueAndValidity();
      }
      else{
        console.log("inside else block in retiredandstudent fun");
        this.requireFields = true;
        this.professionalForm.get('fcnDesignation').setValidators([Validators.required,Validators.pattern('[A-Za-z0-9\\s()-.&:\\/,_]*')]);
      this.professionalForm.get('fcnDesignation').updateValueAndValidity();
      this.professionalForm.get('fcnCompanyName').setValidators([Validators.required,Validators.pattern('[^\\|<>\\?=;,!\\*]*')]);
      this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
      this.professionalForm.get('fcnOfcPin').setValidators([Validators.required, Validators.pattern('^[1-9][0-9]{5}$'), Validators.minLength(6)]);
      this.professionalForm.get('fcnOfcPin').updateValueAndValidity();
      this.professionalForm.get('fcnIncome').setValidators(Validators.required);
      this.professionalForm.get('fcnIncome').updateValueAndValidity();
}
     
    }
  }

  createCompanyList() {
    if (this.masterData) {
      this.companiesToSearch = this.masterData.companyList;
    }
  }

  fetchCityFromPin() {
    if (this.f.fcnOfcPin.value && this.f.fcnOfcPin.value.length == 6 && this.masterData) {
      let cityList: any;
      if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
        cityList = this.masterData.bancaCityList;
      } else {
        cityList = this.masterData.cityList;
      }
      this.providedPin = cityList.find(
        city => city.pin.includes(this.f.fcnOfcPin.value) >= 1
      );
      this.city = this.providedPin ? this.providedPin.name : "";
      this.state = this.providedPin ? this.providedPin.state : "";
      this.stdCode = this.providedPin
        ? this.providedPin.std
          ? this.providedPin.std[0]
          : ""
        : "";
      this.qdeService.officeStdCode = this.stdCode;
      this.qdeService.officeCity = this.city;
      this.providedPin ? this.professionalForm.get('fcnOfcPin').setErrors(null) : this.professionalForm.get('fcnOfcPin').setErrors({ 'pinNotFound': true });
    } else {
      this.providedPin = null;
      this.city = "";
      this.state = "";
      this.stdCode = '';
      this.qdeService.officeStdCode = "";
      this.qdeService.officeCity = "";
    }
    this.sharedService.offStdCode = this.stdCode;
    this.sharedService.officeCity = this.city;
    this.sharedService.officeState = this.state;

  }

  myincomevalue(event: MatSliderChange, abcd) {
    this.f.fcnIncome.setValue(event.value);
  }

  incomeSlider(mySlidervalue, fcnIncome) {
    fcnIncome.value = mySlidervalue;
    if(fcnIncome.value!=0){
      fcnIncome.value <= 200000000 ? this.professionalForm.get('fcnIncome').setErrors(null) : this.professionalForm.get('fcnIncome').setErrors({ 'maxIncome': true });
    }
  }

  patchDetailsForRetrieve() {
    if(this.fromSwiftJourney){
      if (this.sharedService.retrievedApplicationResponse && this.sharedService.retrievedApplicationResponse.data) {
        this.professionalForm.patchValue({
          fcnDesignation: this.sharedService.retrievedApplicationResponse.data.employmentDetails && this.sharedService.retrievedApplicationResponse.data.employmentDetails.designation ? this.sharedService.retrievedApplicationResponse.data.employmentDetails.designation : null,
          fcnCompanyName: this.sharedService.retrievedApplicationResponse.data.employmentDetails && this.sharedService.retrievedApplicationResponse.data.employmentDetails.companyName ? this.sharedService.retrievedApplicationResponse.data.employmentDetails.companyName : null,
          fcnOfcPin: this.sharedService.retrievedApplicationResponse.data.officeAddress && this.sharedService.retrievedApplicationResponse.data.officeAddress.offPinCode ? this.sharedService.retrievedApplicationResponse.data.officeAddress.offPinCode : null,
          fcnOccupationType: this.sharedService.retrievedApplicationResponse.data.employmentDetails && this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType ? this.sharedService.retrievedApplicationResponse.data.employmentDetails.occupationType : null,
          fcnPan: this.sharedService.retrievedApplicationResponse.data.applicantDetails && this.sharedService.retrievedApplicationResponse.data.applicantDetails.pan ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.pan : null,
          fcnIncome: this.sharedService.retrievedApplicationResponse.data.incomePa ? this.sharedService.retrievedApplicationResponse.data.incomePa : null,
          fcnDOB: this.sharedService.retrievedApplicationResponse.data.applicantDetails && this.sharedService.retrievedApplicationResponse.data.applicantDetails.dateOfBirth ? this.sharedService.retrievedApplicationResponse.data.applicantDetails.dateOfBirth : null,
  
        })
        if(this.sharedService.retrievedApplicationResponse.data.employmentDetails && this.sharedService.retrievedApplicationResponse.data.employmentDetails.companyName){
          //let compAliase = this.companiesToSearch.find(comp => comp.companyName === this.f.fcnCompanyName.value);
          let compAliase = this.companiesToSearch.find(comp => comp.cmpNm === this.f.fcnCompanyName.value);
          //this.qdeService.natureOfCompany = compAliase ? compAliase.natureOfCompany : 'C';
        }
        if(this.sharedService.retrievedApplicationResponse.data.employmentDetails && this.sharedService.retrievedApplicationResponse.data.employmentDetails.designation){
          let desigInList = this.designationToSearch.find(desg => desg === this.f.fcnDesignation.value);
          this.qdeService.designationFlag = desigInList ? '0' : '1';
        }
  
        this.fetchCityFromPin();
        this.mySlider.value = this.f.fcnIncome.value
        if (this.f.fcnOccupationType.value) {
          let name;
          let name1
          this.occupations.forEach(element => {
            if (element.key_value == this.f.fcnOccupationType.value)
              name1 = element.key_name
          });
          name = name1.replace(/[&\/\\#,+()$~%.'":*?<>{}' ']/g, '');
          name = name.replace(/' '/g, '');
          this.designationImg = this.designationImgUrl + name + ".png"
          
        }
      }
    }
    else{
      if (this.sharedService.retrievedApplicationResponse && this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType) {
        this.professionalForm.patchValue({
          fcnDesignation: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation : null,
          fcnCompanyName: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany : null,
          fcnOfcPin: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOfficePincode ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOfficePincode : null,
          fcnOccupationType: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode : null,
          fcnPan: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber : null,
          fcnIncome: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserAnnualIncomeValue ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserAnnualIncomeValue : null,
          fcnDOB: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB ? this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB : null,
  
        })
        if(this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany){
          //let compAliase = this.companiesToSearch.find(comp => comp.companyName === this.f.fcnCompanyName.value);
          let compAliase = this.companiesToSearch.find(comp => comp.cmpNm === this.f.fcnCompanyName.value);
          //this.qdeService.natureOfCompany = compAliase ? compAliase.natureOfCompany : 'C';
        }
        if(this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation){
          let desigInList = this.designationToSearch.find(desg => desg === this.f.fcnDesignation.value);
          this.qdeService.designationFlag = desigInList ? '0' : '1';
        }
  
        this.fetchCityFromPin();
        this.mySlider.value = this.f.fcnIncome.value
        if (this.f.fcnOccupationType.value) {
          let name;
          let name1
          this.occupations.forEach(element => {
            if (element.key_value == this.f.fcnOccupationType.value)
              name1 = element.key_name
          });
          name = name1.replace(/[&\/\\#,+()$~%.'":*?<>{}' ']/g, '');
          name = name.replace(/' '/g, '');
          this.designationImg = this.designationImgUrl + name + ".png"
          
        }
      }
    }
    
  }
  showLable() {
    (this.f.fcnCompanyName.value && this.f.fcnCompanyName.value.length) === 0 ? this.placeholder = true : true;
  }
  hideLable() {
    (this.f.fcnCompanyName.value && this.f.fcnCompanyName.value.length) === 0 ? this.placeholder = true : this.placeholder = false;
  }
  showLable1() {
    (this.f.fcnOccupationType.value.length) === 0 ? this.placeholder = true : true;
  }
  hideLable1() {
    (this.f.fcnOccupationType.value.length) === 0 ? this.placeholder = true : this.placeholder = false;
  }
  focusOut() {
    this.placeholder = false;
  }
  checkValidationFromDropdown(){
    let checkDropdown= !this.f.fcnCompanyName.value.includes(this.filterCompany);
    console.log(this.f.fcnCompanyName.value.includes(this.filterCompany));
   
    if (checkDropdown && this.f.fcnOccupationType.value === "P" || this.f.fcnOccupationType.value === "T"){
      console.log("forretired and student");
      console.log("inside value" +this.f.fcnOccupationType.value);
      this.requireFields=false;
      this.professionalForm.get('fcnCompanyName').setValidators(null);
      this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
    }
    else  if (!checkDropdown && this.f.fcnOccupationType.value === "P" || this.f.fcnOccupationType.value === "T"){
      console.log("for retired and student");
      console.log("inside value" +this.f.fcnOccupationType.value);
      this.requireFields=false;
      this.professionalForm.get('fcnCompanyName').clearValidators();
      this.professionalForm.get('fcnCompanyName').setValidators(Validators.pattern('^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+'));
      this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
    }
    // if(this.f.fcnCompanyName.value && value.length >= 3){
   else if(checkDropdown && (this.f.fcnOccupationType.value != "P" || this.f.fcnOccupationType.value != "T")){
    // this.requireFields = false;
    console.log("value from dropdown");
    //if(companyvalidation){
      // console.log("inside if ");
       console.log("inside value" +this.f.fcnOccupationType.value);

      this.professionalForm.get('fcnCompanyName').setValidators(Validators.required);
      this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
      // this.dataFromDropdown=false;
      // this.retiredAndStudentValidation(this.f.fcnOccupationType.value);
     // this.dataFromDropdown=false;
  //  }
  }
  else if(!checkDropdown && (this.f.fcnOccupationType.value != "P" || this.f.fcnOccupationType.value != "T")){
    console.log("value not from dropdown");
    console.log("inside value" +this.f.fcnOccupationType.value);
    this.professionalForm.get('fcnCompanyName').setValidators([Validators.required,Validators.pattern('^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+')]);
    this.professionalForm.get('fcnCompanyName').updateValueAndValidity();
  }
  
  }
  callFormAbandon(label) {
    if (!this.sharedService.formFieldTouch) {
      this.sharedService.formFieldTouch = true;
      if(window['_satellite']){
        _satellite.track('form_start')
      }
    }
    let abandonRequest: any;
    abandonRequest = {
      section: "Professional Details",
      field: label
    }
    this.sharedService.setAnalyticsFormAbandon(abandonRequest);
  }

  callMaster(){
    let masterReq = {
      cardType: this._cardtype,
      cardChannelCode: 'EAPL',
      cityList: 'N',
      companyList: 'N',
      bancaCityList: 'N',
      userCity: this.city
    }
    if (this.isBanca) {
      masterReq.cardChannelCode = 'EALB';
    } else if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701')) {
      masterReq.cardChannelCode = 'EABP';
    }
    else if(this.sharedService.fromSwiftJourney) {
      masterReq.cardChannelCode = 'SAPL';
    }
    this.loaderService.show()
    this.qdeService.fetchMatserData(masterReq).subscribe((res: any) => {
      if (res && res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.statusCode === "000") {
        console.log("inside call master data success");
        this.loaderService.hide()
        this.sharedService.sourceCode = 'DEFEAP';
        this.wsDetails.WSCallAppSourceCode = 'DEFEAP';
        this.wsDetails.WSCallPromoCode = this.sharedService.promoCode;
        this.sharedService.InitialMasterResponse = res
        if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.wcpParameters) {
          this.sharedService.sourceCode = res.eapplyMasterDataRsType.wcpParameters.sourceCode;
          this.sharedService.promoGroup = res.eapplyMasterDataRsType.wcpParameters.promoGroup;
          this.wsDetails.WSCallAppSourceCode = res.eapplyMasterDataRsType.wcpParameters.sourceCode;
          this.wsDetails.WSCallApplicationSource = res.eapplyMasterDataRsType.wcpParameters.promoGroup;
        }
        if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
          if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode) {
            this.sharedService.promoCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode;
            this.wsDetails.WSCallPromoCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode;
          } else {
            if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
              if (this._cardtype == 'USV2') {
                this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-code').key_value;
                this.wsDetails.WSCallPromoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-code').key_value;
              } else {
                this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-code').key_value;
                this.wsDetails.WSCallPromoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-code').key_value;
              }
            }
          }
          this.wsDetails.WSCallPromoCode = this.sharedService.promoCode;
          if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup) {
            this.sharedService.promoGroup = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup;
            this.wsDetails.WSCallApplicationSource = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup;
          } else {
            if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
              if (this._cardtype == 'USV2') {
                this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-group').key_value;
                this.wsDetails.WSCallApplicationSource = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-group').key_value;
              } else {
                this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-group').key_value;
                this.wsDetails.WSCallApplicationSource = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-group').key_value;
              }
            }
          }

          if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode) {
            this.sharedService.sourceCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode;
            this.wsDetails.WSCallAppSourceCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode;
          } else {
            if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
              this.sharedService.sourceCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-source-code').key_value;
              this.wsDetails.WSCallAppSourceCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-source-code').key_value;
            } else{
              this.sharedService.sourceCode = 'DEFEAP';
              this.wsDetails.WSCallAppSourceCode = 'DEFEAP';
            }
          }

        }
        this.requestData = Object.assign({}, this.qdeService.aboutData, this.wsDetails);
        console.log("requestData from professional details", this.requestData);
        this.professionReq.wsCallDetailsData = this.requestData;
        this.professionReq = this.trimObject(this.professionReq);
        console.log("professionReq from professional details", this.professionReq);
        this.callCreateUpdateLead(this.professionReq);

      } else {
        this.loaderService.hide()
        console.log("else for callMaster data service"); 
        this.errorMessage = GENERIC_ERROR;
      }
    }, err => {
      this.errorMessage = GENERIC_ERROR;
      console.log("error from master data call");
      this.loaderService.hide()
      window["digitalData"].error = { message: GENERIC_ERROR };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
    });
  }

  fetchCompDesg(){
    this.sharedService.compDesObservavle.subscribe((data:any)=>{
      this.companiesToSearch = data.comp;
      this.designationToSearch = data.desg;
    })
  }
}
